// src/components/store/sections/faqs/FaqV8SteppernumberedSunsetAmber.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV8SteppernumberedSunsetAmber(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={8}
      archKey="stepper_numbered"
      archLabel="Numbered Stepper FAQ"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
